var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReactivateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4577_40663)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#EDFCF5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4577_40663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 15.6877L15.25 11.7502L10 7.81274V15.6877ZM11.75 3.00024C6.92 3.00024 3 6.92024 3 11.7502C3 16.5802 6.92 20.5002 11.75 20.5002C16.58 20.5002 20.5 16.5802 20.5 11.7502C20.5 6.92024 16.58 3.00024 11.75 3.00024ZM11.75 18.7502C7.89125 18.7502 4.75 15.609 4.75 11.7502C4.75 7.89149 7.89125 4.75024 11.75 4.75024C15.6087 4.75024 18.75 7.89149 18.75 11.7502C18.75 15.609 15.6087 18.7502 11.75 18.7502Z",
    fill: "#00754E"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 3.25,
    stroke: "#BFEDD9",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4577_40663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4577_40663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(-4 -4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactivateIcon);
export default __webpack_public_path__ + "static/media/reactivate_icon.e1c17b11eac2a951daf90fc7befbe06c.svg";
export { ForwardRef as ReactComponent };